import { useState, useEffect, Dispatch, SetStateAction } from 'react';

export function usePersistentState<T>(key: string, defaultValue: T): [T, Dispatch<SetStateAction<T>>] {
    const [value, setValue] = useState<T>(() => {
        try {
            const savedValue = localStorage.getItem(key);
            if (savedValue !== null) {
                return JSON.parse(savedValue) as T;
            }
        } catch (error) {
            console.warn(`Error parsing localStorage key "${key}":`, error);
        }
        return defaultValue;
    });

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};